(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6091],{

/***/ 35035:
/***/ (function(module) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 72659:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/despre-noi",
      function () {
        return __webpack_require__(13353);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/structuredData.js
var structuredData = __webpack_require__(89229);
;// CONCATENATED MODULE: ./components/BreadcrumbSchema.js




var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, baseUrl = _publicRuntimeConfig.settings.baseUrl;
var BreadcrumbSchema = function(param) {
    var breadcrumbData = param.breadcrumbData, currentPath = param.currentPath;
    // Do not include home page
    // Do not include pages without parent
    if (breadcrumbData && breadcrumbData.length > 1) {
        var itemListElement = breadcrumbData.map(function(breadcrumb, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                name: breadcrumb.name,
                item: breadcrumb.level != 99 ? "".concat(baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || "") : "".concat(baseUrl).concat(currentPath)
            };
        });
        var schema = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: itemListElement
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: (0,structuredData/* default */.Z)(schema)
            }
        }));
    }
    return null;
};
/* harmony default export */ var components_BreadcrumbSchema = (BreadcrumbSchema);

;// CONCATENATED MODULE: ./components/Breadcrumbs.js








var Breadcrumbs_ref = (0,config["default"])(), settings = Breadcrumbs_ref.publicRuntimeConfig.settings;
var isBricoStore = settings.websiteName === "bricostore";
var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, _isPDP = param.isPDP, isPDP = _isPDP === void 0 ? false : _isPDP, className = param.className;
    var router = (0,next_router.useRouter)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BreadcrumbSchema, {
                breadcrumbData: breadcrumbs,
                currentPath: router.asPath
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Breadcrumbs is-hidden-in-mobile-app pb-3 lg:py-3 truncate text-sm ".concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                    className: "p-0 m-0 list-none inline",
                    children: breadcrumbs.map(function(breadcrumb, index) {
                        return breadcrumb.level != 99 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: classnames_default()("inline", {
                                "text-red-brand": isBricoStore || !isPDP,
                                "text-[#1D4ED8]": !isBricoStore && isPDP
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "".concat(settings.baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        title: breadcrumb.name,
                                        className: classnames_default()({
                                        }),
                                        children: breadcrumb.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mx-1",
                                    children: "/"
                                })
                            ]
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "inline",
                            children: breadcrumb.name
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index));
                    })
                })
            })
        ]
    }));
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        level: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired,
        url_key: function(props, propName) {
            if (props["level"] !== 99 && (typeof props[propName] !== "string" || props[propName].length === 0)) {
                return new Error("Please provide url_key when item level is not 99.");
            }
        },
        url_suffix: (prop_types_default()).string
    })).isRequired
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 61167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var withRouterPageLayout = function(ComposedComponent) {
    var WithRouteWrapper = /*#__PURE__*/ function(Component1) {
        "use strict";
        _inherits(WithRouteWrapper, Component1);
        var _super = _createSuper(WithRouteWrapper);
        function WithRouteWrapper() {
            _classCallCheck(this, WithRouteWrapper);
            return _super.apply(this, arguments);
        }
        _createClass(WithRouteWrapper, [
            {
                key: "render",
                value: function render() {
                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ComposedComponent, _objectSpread({
                        router: this.context.router
                    }, this.props)));
                }
            }
        ]);
        return WithRouteWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_1__.Component);
    _defineProperty(WithRouteWrapper, "contextTypes", {
        router: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)
    });
    WithRouteWrapper.getInitialProps = ComposedComponent.getInitialProps;
    // Hoists non standard static properties
    WithRouteWrapper.pageLayout = ComposedComponent.pageLayout;
    WithRouteWrapper.layoutProps = ComposedComponent.layoutProps;
    WithRouteWrapper.pageName = ComposedComponent.pageName;
    return WithRouteWrapper;
};
/* harmony default export */ __webpack_exports__["Z"] = (withRouterPageLayout);


/***/ }),

/***/ 89229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35035);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__);

// JSON-LD blocks are injected with dangerouslySetInnerHTML, so a "<" coming
// from product data (a "</script>" inside a product name or description) would
// close the script element early and make the whole block unparsable for
// crawlers, besides letting the markup run in the browser. These characters
// are only ever part of JSON string values, where the escaped form is
// equivalent, so escaping them keeps the JSON valid and the page safe.
var HTML_UNSAFE_ESCAPES = {
    "<": "\\u003c",
    ">": "\\u003e",
    "&": "\\u0026"
};
var serializeSchema = function(schema) {
    return fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default()(schema).replace(/[<>&]/g, function(character) {
        return HTML_UNSAFE_ESCAPES[character];
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (serializeSchema);


/***/ }),

/***/ 13353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ despre_noi; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./components/withRouterPageLayout.js
var withRouterPageLayout = __webpack_require__(61167);
// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
;// CONCATENATED MODULE: ./lib/aboutUsContent.js


var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var content = {
    altex: {
        title: "Altex, 30 de ani de experienta in sprijinul clientilor si partenerilor nostri",
        image: [
            {
                path: "".concat(settings.websiteStatics, "/images/about-us/about-us-mobile.svg"),
                media: "(max-width: 640px)",
                isDefault: false
            },
            {
                path: "".concat(settings.websiteStatics, "/images/about-us/about-us.svg"),
                isDefault: true
            }, 
        ],
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Altex este unul dintre cele mai bune exemple de antreprenoriat de succes din Romania. A pornit ca un business local de import televizoare, dar a reusit sa devina liderul pietei romanesti de retail electro-IT, in 30 de ani plini de provocari si adaptare continua la schimbarile din mediul de afaceri."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Reteta Altex? A pus mereu clientul pe primul plan si a construit o infrastructura care sa corespunda exigentelor pietei."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Inca de la infiintare, compania si-a propus sa ofere produse de calitate adecvate dorintelor consumatorilor si solutii de finantare acesibile."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-2xl leading-32 md:text-3xl md:leading-42 text-red-brand mb-4",
                    children: "Tehnologie accesibila tuturor clientilor"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Altex are misiunea de a aduce tehnologia de ultima generatie in casele tuturor romanilor, prin produse si servicii care le satisfac nevoile. Conceptul omnichannel, a carui implementare a inceput in 2014, aduce confort si usurinta in procesul de informare, luare a deciziei, interactiune cu produsul, cumparare si apoi utilizare."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "mb-4",
                    children: [
                        "Ca reprezentanti ai companiei, ne mandrim ca suntem una dintre cele mai importante companii private romanesti si",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://altex.ro/",
                            target: "_blank",
                            rel: "noreferrer",
                            className: "font-semibold underline",
                            children: "liderul pietei de produse electronice, electrocasnice, IT&C"
                        }),
                        " ",
                        "si multimedia din Romania."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Reteaua noastra nationala de magazine (peste 125 magazine Altex) se afla in continua expansiune, la fel si gamele de produse pe care le comercializam, la cele mai avantajoase preturi. Nu doar deschidem noi unitati, in orase mari si medii din toata tara, dar am inceput si un amplu proces de reamenajare si modernizare a celor deja existente."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Suntem incantati ca putem oferi clientilor nostri o gama variata de electrocasnice mici si mari, cosmetice, obiecte de voiaj, articole pentru copii si bebelusi, biciclete electrice, masini second hand, laptopuri, telefoane, produse software, aparate de aer conditionat, jocuri pentru PC si diverse console (cum ar fi PS sau Xbox), calculatoare pentru gaming si multe alte produse."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Gama de produse este atent gandita, avand ca principal criteriu calitatea si performanta produsului."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-2xl leading-32 md:text-3xl md:leading-42 text-red-brand mb-4",
                    children: "Solutii de finantare"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "mb-4",
                    children: [
                        "Pentru clientii nostri, am infiintat",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://altex.ro/solutii-finantare/credit-online/",
                            target: "_blank",
                            rel: "noreferrer",
                            className: "font-semibold underline",
                            children: "Credex"
                        }),
                        ", o companie de credite de consum, care ii ajuta cu solutii optime de finantare, la achizitia produselor din magazinele Altex si de pe altex.ro. Solutiile de finantare pe care le-am gandit sunt extrem de flexibile si se remarca prin dobanzi si rate mici."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Cei peste 4.000 de angajati Altex din magazine, de la sediul central din Voluntari si din depozitele de marfa incearca, in fiecare zi, sa ofere cele mai bune experiente de interactiune cu brandul."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Doar asa putem oferi „cel mai mic pret din Romania” si sustine promisiunea de a returna “de 2 x diferenta, daca gasesti in alta parte mai ieftin”."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Cu ajutorul colegilor din magazine si al produselor expuse, completam oferta de pret cu o experienta reala, convingatoare, care sa dea clientului increderea ca a facut cea mai buna investitie."
                })
            ]
        })
    },
    mediagalaxy: {
        title: "Profilul companiei Media Galaxy",
        image: [
            {
                path: "https://lcdn.mediagalaxy.ro/LP/ATX/blog/media_galaxy_show_room_1_24160700_df76b461.jpg",
                isDefault: true
            }, 
        ],
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Media Galaxy reprezinta una dintre cele mai mari retele de magazine cu vanzare de produse electronice si electrocasnice ce activeaza pe piata romanasca, punand la dispozitia clientilor o gama variata de produse atat online, cat si offline, in cele mai mari orase ale tarii: Bucuresti, Cluj, Iasi, Arad, Brasov, Constanta, Timisoara, Pitesti, Baia Mare, Oradea, Craiova, Targul Mures, Suceava."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Media Galaxy este alaturi de clientii sai de 16 ani, de cand a inaugurat pe piata din Romania un nou concept: o retea de magazine de mare suprafata, care sa ofere cea mai variata gama de produse, sa reflecte pasiunea pentru tehnologie si dorinta de a pune la dispozitia clientilor cele mai noi device-uri. Spatiile generoase, de peste 3.000 mp pe magazin, precum si selectia produselor, inseamna in primul rand o mare libertate de alegere pentru fiecare client care trece pragul magazinelor."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Cele 19 magazine de mare suprafata Media Galaxy reflecta pasiunea pentru tehnologie si pentru dispozitivele care fac accesibila informatia si conexiunea cu ceilalti. Printr-o selectie relevanta de branduri, alaturi de servicii de calitate, Media Galaxy aduce tehnologia mai aproape de consumatori, facand-o mai accesibila devenind o parte fireasca a vietii acestora."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: " "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-2xl leading-32 md:text-3xl md:leading-42 text-red-brand mb-4",
                    children: "Cea mai variata gama de produse electronice si electrocasnice\xa0\xa0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "mb-4",
                    children: [
                        "In magazinele Media Galaxy si pe site-ul mediagalaxy.ro gasesti",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://mediagalaxy.ro/promo/",
                            target: "_blank",
                            rel: "noreferrer",
                            className: "font-semibold underline",
                            children: "oferte la electrocasnice si electronice"
                        }),
                        ", precum si la categorii noi de produse – articole de voiaj si trolere, cosmetice si parfumuri, cafea, sucuri si apa sau articole pentru copii si bebelusi. Ai la dispozitie reduceri la cele mai cunoscute branduri de televizoare, precum si la o gama larga de produse si gadget-uri IT, incepand cu cele mai performante laptopuri si ajungand la sisteme PC, software si retelistica. Iti poti comanda orice produs de care ai nevoie in gospodarie: frigider, masina de spalat, aragaz sau expresor, precum si fiare de calcat, aspiratoare sau roboti de bucatarie. Poti descoperi o serie variata de modele de camere foto si aparate video, telefoane de ultima generatie si kit-uri smart home.",
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Pentru pasionatii de gaming Media Galaxy ofera o gama variata de console gaming – PS4, Xbox si Nintendo, precum si jocurile potrivite pentru acestea. Nici zona auto nu ramane mai prejos – la Media Galaxy gasesti anvelope, accesorii auto si chiar masini second hand."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Media Galaxy ofera consumatorilor cea mai variata gama de produse si o selectie importanta de branduri de calitate, iar prin serviciul “Rambursam diferenta” primesti diferenta de pret sub forma de voucher daca gasesti un pret mai mic in alta parte."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: " "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-2xl leading-32 md:text-3xl md:leading-42 text-red-brand mb-4",
                    children: "Strategie omnichannel"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Media Galaxy pune consumatorul in centrul proceselor de business si dezvolta constant strategia omnichannel pentru ca experienta cumparatorilor sa fie similara atat in mediul online cat si in mediul offline al magazinelor. Media Galaxy traduce printr-o dezvoltare omnichannel nevoia de a fi oricand si oriunde este clientul."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Inca de la primul magazin aparut pe piata, in Bucuresti Mall Vitan, Media Galaxy si-a respectat promisiunea de a aduce cea mai variata gama de produse, oferindu-i mereu expertiza pe toate ariile de echipamente electronice. De asemenea, ofera servicii precum consilierea avizata din partea unor specialisti pregatiti, serviciul de livrare, de instalare la cerere sau cel de extragarantie."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "\xa0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: "text-2xl leading-32 md:text-3xl md:leading-42 text-red-brand mb-4",
                    children: [
                        "Servicii de calitate si solutii de finantare\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Nu-ti face griji pentru buget, fiindca ai la dispozitie metode de creditare variate, care iti permit sa cumperi acum de la Media Galaxy si sa platesti in timp cumparaturile, fara a le simti la buzunar! Beneficiezi de rate fara dobanda prin cardul BRD, precum si variante flexibile de rate de la ING, Banca Transilvania, Raiffeisen, Piraeus, Alpha Bank, Euroline, Unicredit sau Card Avantaj."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "De asemenea, poti cumpara rapid si fara acte suplimentare prin sistemul de rate Credex."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Vino la unul dintre magazinele din centrele comerciale, in reprezentantele din spatii proprii sau cumpara direct de pe site, pentru ca vei gasi intotdeauna ceea ce iti promitem: cea mai variata gama de produse, super oferte si inovatie constanta!"
                })
            ]
        })
    },
    bricostore: {
        title: "Profilul companiei Brico",
        image: [
            {
                path: "https://lcdn.bricostore.ro/LP/ATX/blog/Brico-Header-LP_68a3d1f5.jpg",
                isDefault: true
            }, 
        ],
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-2xl leading-32 md:text-3xl md:leading-42 text-red-brand mb-4",
                    children: "Istoria Brico in Romania"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Brico este un brand de referinta in sectorul bricolajului, constructiilor si amenajarilor interioare, oferind solutii eficiente pentru proiecte de casa si gradina. Prezent pe piata din Romania din 2013 (initial sub numele Brico Depot), brandul s-a remarcat printr-un concept de tip preturi mici zilnic, stocuri mari si produse esentiale pentru profesionisti si pasionati de bricolaj."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Reteaua a trecut printr-o etapa importanta de transformare si consolidare, devenind un jucator cunoscut in randul celor care cauta mobilier de gradina, baie sau bucatarie, materiale de constructii, unelte, vopsele si alte produse necesare in renovari si proiecte DIY."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "In mai 2025 Brico Depot a fost preluat de grupul Altex, lider pe piata de retail electro-IT din Romania. Aceasta preluare marcheaza inceputul unui nou capitol, in care brandul devine Brico, cu obiectivul de a extinde gama de produse, serviciile si infrastructura digitala, pentru a raspunde mai bine nevoilor clientilor."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Astazi, Brico continua sa deserveasca clientii printr-o retea extinsa de magazine fizice si prin platforma online bricostore.ro, ramanand un partener de incredere pentru mesteri, echipe de constructii, dar si pentru cei care isi fac singuri proiectele de renovare."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-2xl leading-32 md:text-3xl md:leading-42 text-red-brand mb-4",
                    children: "Astazi, Brico Romania:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Brico Romania detine 30 de magazine si ofera solutii accesibile pentru renovari si constructii, atat pentru clienti individuali, cat si profesionisti."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Magazinele Brico sunt localizate strategic in marile orase, oferind acces facil si consiliere specializata. In plus, platforma online bricostore.ro completeaza experienta de cumparare, punand la dispozitie informatii clare, oferte actualizate si posibilitatea de a comanda produsele dorite direct de acasa sau de pe santier."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-4",
                    children: "Prin dezvoltarea retelei, digitalizarea serviciilor si extinderea gamei de produse, Brico Romania isi consolideaza pozitia ca partener de incredere pentru proiecte de bricolaj si constructii, indiferent daca sunt realizate de amatori sau de echipe profesioniste."
                })
            ]
        })
    }
};

;// CONCATENATED MODULE: ./pages/despre-noi.js








var despre_noi_ref = (0,config["default"])(), despre_noi_settings = despre_noi_ref.publicRuntimeConfig.settings;
var AboutUs = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Despre noi"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                breadcrumbs: [
                    {
                        id: 1,
                        level: 99,
                        name: "Despre noi"
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                as: "h2",
                display: "h1",
                title: content[despre_noi_settings.websiteName].title,
                classesProp: "mt-6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                children: content[despre_noi_settings.websiteName].image.map(function(img) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                        children: !img.isDefault ? /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            srcSet: img.path,
                            media: img.media
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "w-full my-8 lg:mt-42px lg:mb-77px",
                            alt: "Altex, 30 de ani alaturi de clientii si partenerii nostri",
                            src: img.path
                        })
                    }, img.path);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                className: "columns-2 gap-[30px] md:gap-[105px] leading-relaxed lg:w-3/4 mx-auto",
                children: content[despre_noi_settings.websiteName].content
            })
        ]
    }));
};
AboutUs.pageLayout = "default";
/* harmony default export */ var despre_noi = ((0,withRouterPageLayout/* default */.Z)(AboutUs));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(72659); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);